import { LoaderCircle } from 'lucide-react';
import type { ComponentProps } from 'react';

export function ActionButton({
  variant = 'quiet',
  busy = false,
  children,
  ...props
}: ComponentProps<'button'> & { variant?: 'primary' | 'secondary' | 'quiet'; busy?: boolean }) {
  return (
    <button
      type="button"
      {...props}
      className={`pc-btn ${props.className ?? ''}`}
      data-variant={variant}
      aria-busy={busy || undefined}
      aria-label={props['aria-label'] ?? (typeof children === 'string' ? children : undefined)}
    >
      <span className={busy ? 'pc-action-button-label-busy' : undefined}>{children}</span>
      {busy && <LoaderCircle className="pc-action-button-spinner" aria-hidden="true" />}
    </button>
  );
}
